define([
    "./monitoringQueryModule"
], function (module) {
    "use strict";

    return module.service("monitoringQueryService", ["nlgScriptSqlServiceFactory", function (nlgScriptSqlServiceFactory) {
        return nlgScriptSqlServiceFactory("../cockpit-gateway/monitoring");
    }]);
});